module.exports = "<div class =\"ot-host\">\n  <ot-avatar params=\"{\n                      image: {src: params.host.avatar, size: 'lg'},\n                      initials: {'first_name': params.host.first_name, 'last_name': params.host.last_name}\n                    }\"></ot-avatar>\n  <div>\n    <p>{{params.host.bio}}</p>\n    <button class=\"btn btn-default\">{{'EVENT.SEND_MESSAGE' | translate}}</button>\n  </div>\n\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/directives/content/host.html
 ** module id = 265
 ** module chunks = 1
 **/